export default __webpack_public_path__ + "static/media/b6ae81d90e46cfa2c3affcfb7127a78f1600803228537.1fbefda2.webp";